module.exports = __webpack_public_path__ + "static/Element57-eec36cd3a9ee60a2317acfeb1e5627aa.png";